import { render, staticRenderFns } from "./BoostifyApp.vue?vue&type=template&id=37a1c9d7&scoped=true"
import script from "./BoostifyApp.vue?vue&type=script&lang=js"
export * from "./BoostifyApp.vue?vue&type=script&lang=js"
import style0 from "./BoostifyApp.vue?vue&type=style&index=0&id=37a1c9d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a1c9d7",
  null
  
)

export default component.exports